import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from "./actions";
import { AddressTypeType } from "./address_type.type";
import { getAddressTypesApi } from "../../services/address_types.service";
import { AxiosResponse } from 'axios';

export function* GET_ALL_ADDRESS_TYPES() {
    try {
        const response: AxiosResponse<AddressTypeType[]> = yield call(getAddressTypesApi);
        if (response.data) {
            const data = response.data.map((el: AddressTypeType, key: Number) => ({...el, key: (Number(key) + 1)}));
            yield put({
                type: actions.SET_DATA,
                payload: data
            })
        }
    } catch (e) {

    }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_DATA, GET_ALL_ADDRESS_TYPES),
    ])
}
